import { createContext, useContext } from "react";

// Nested menus must stay inside the active dialog's scroll-lock boundary.
export const OverlayPortalContext = createContext<HTMLElement | null>(null);
export const useOverlayPortalContainer = (): HTMLElement | null =>
  useContext(OverlayPortalContext);
